<div class="app-header-player">
  <div class="row p-0 m-0" style="max-height: 50px">
    <div
      class="col-sm-2 p-0 m-0"
      style="width: 71px; max-height: 50px; background-color: #ffffff"
    >
      <img
        [src]="stationLogo"
        class="station-logo"
        (error)="setPlaceholderImage()"
      />
    </div>
    <div class="col-sm-7 p-0 m-0" style="max-height: 50px">
      <app-audio-player></app-audio-player>
    </div>
    <div class="col-sm-3 p-0 m-0" style="max-height: 50px">
      <button
        mat-raised-button
        (click)="downloadAudio()"
        style="margin-top: 6px; margin-left: 10px"
      >
        Download Audio
      </button>
    </div>
  </div>
</div>
